module.exports = __webpack_public_path__ + "media/PAG87-03.10a34e3a.mp3";